import type { HTMLAttributes } from "react";
import { cn } from "../cn";

/** A key, as printed on it. */
export function Kbd({ className, ...props }: HTMLAttributes<HTMLElement>) {
  return (
    <kbd
      className={cn(
        "inline-flex items-center rounded-[var(--radius-sm)] bg-sunk px-1.5 font-mono text-meta text-ink-2",
        className,
      )}
      {...props}
    />
  );
}
